var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-icon',{staticClass:"rounded-circle tableActionBTN mr-2",class:'ikon '+_vm.iconName,attrs:{"scale":".5","font-scale":"1.6","variant":"light"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }